import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Redux
import { userSelector } from 'Redux/LoggedUserSlice';

// Constants
import { EMPLOYEE_ROLE_ID } from 'Constants/General';

// Hooks
import useTranslation from 'Hooks/useTranslation';

// Components
import { EvaluationContainer, LoadingContainer } from './style';
import EvaluationCard from './Components/EvaluationCard';
import useEvaluationsTab from './Hooks/useEvaluationsTab';

export default function Evaluations({ course }) {
  // Diccionario
  const { t2 } = useTranslation('CourseDetails');

  // Course ID
  const courseId = course[course.length - 1];

  // Obtenemos el ROL del usuario
  const { roleId, id } = useSelector(userSelector);

  // Obtenemos la ubicación actual
  const location = useLocation();

  // Obtenemos el origen de la navegación
  const isComingFrom = location?.state?.isComingFrom;

  // Obtenemos el historial de navegación
  const history = useHistory();

  // Obtenemos las evaluaciones del usuario de este curso
  const { userEvaluations } = useEvaluationsTab({ courseId, userId: id });
  // TODO: Refactorizar para obtener más datos de las evaluaciones

  // Si no hay evaluaciones, mostramos un mensaje de carga
  if (userEvaluations?.length === 0) {
    return <LoadingContainer>{t2('NoEvaluations')}</LoadingContainer>;
  }

  return (
    <EvaluationContainer>
      {userEvaluations &&
        userEvaluations.map((userEvaluation, index) => {
          return (
            <EvaluationCard
              key={userEvaluation.userEvaluationId || index.toString()}
              isEmployee={roleId === EMPLOYEE_ROLE_ID}
              userEvaluation={userEvaluation}
              courseId={courseId}
              courseName={course[0]}
              onClick={
                (isComingFrom === '/cursos' || isComingFrom === '/dashboard' || isComingFrom === '/mis-cursos') &&
                !(roleId === EMPLOYEE_ROLE_ID)
                  ? () => history.push(`/cursos/${courseId}/lecciones/${userEvaluation.lessonId}`)
                  : null
              }
            />
          );
        })}
    </EvaluationContainer>
  );
}
